import React, {Component} from 'react';
import {TopSelect} from "../../../../../componentsTopsa/selects/TopSelects";
import ClientService from "../../biletyApi/ClientService";

export default class GodzinaInTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            kurs: null,
            kursy: [],
            godz: '',
            obj: null,
            czyPokazacSelect: false
        };
        this.onChangeKurs = this.onChangeKurs.bind(this)
        this.onClickBtn = this.onClickBtn.bind(this)
    }

    componentDidMount() {
        this.setState({godz: this.props.godz, obj: this.props.obj})
    }

    componentWillReceiveProps(nextprops) {
        this.setState({godz: nextprops.godz, obj: nextprops.obj})
    }

    pobierzKursy(obj) {
        ClientService.getKursyMiedzyPrzystankamiWDanymCzasie(obj).then(function (response) {
            if (response.data.length > 0) {
                let kurs = response.data.find(k => k.godz === this.state.godz)
                this.setState({
                    kursy: response.data,
                    kurs: Boolean(kurs) ? kurs : null
                })
            }

        }.bind(this))
    }

    onChangeKurs(e) {
        this.setState({kurs: e, czyPokazacSelect: false})
        this.props.handleChangeGodzina(e.idKu)
    }

    onClickBtn() {
        this.setState({
            czyPokazacSelect: true
        })
        this.pobierzKursy(this.state.obj)
    }

    render() {

        return (
            <div>
                {
                    Boolean(this.state.czyPokazacSelect) ?
                        <TopSelect onChange={this.onChangeKurs}
                                   value={this.state.kurs}
                                   options={this.state.kursy}
                                   clearable={false}
                                   labelKey={'godz'}
                                   valueKey={'idKu'}
                        />
                        :
                        <div>
                            <span>{this.state.godz}</span>
                            {
                                Boolean(!this.props.noedit) ?
                                    <i className={'fa fa-pencil'} onClick={this.onClickBtn} style={{marginLeft: '5px', cursor: 'pointer'}}></i>
                                    :
                                    ''
                            }
                        </div>
                }

            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/biletyJednorazowe/components/GodzinaInTable.js